<ax-panel-box caption="{{ caption | word}}" [allowCollapse]="false"  [collapsed]="false" *ngIf="visible" >
    <ng-container *ngFor="let w of widgets" axf-widget-renderer [widget]="w" mode='print' [parent]="this">
    </ng-container>
</ax-panel-box>